import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const PartnerCarouselContainer = styled.div`
  background: #f7f7f7;

  img {
    height: 200px;
  }

  .slick-list {
    @media (max-width: 565px) {
      height: 588px;
    }
  }
`;

const CarouselItem = styled.div`

`;

const CarouselItemInner = styled.div`
  background: white;
  margin: 15px;
  border-radius: 12px;
  padding: 25px;

  @media (min-width: 450px) {
    padding: 60px;
  }

  @media (min-width: 852px) {
    display: flex;
    flex-direction: row-reverse;
    justify-items: space-between;
    padding: 108px 122px 108px 136px;
  }
`;

const ImgContainer = styled.div`
  text-align: center;

  img {
    margin: 0 auto;
  }
`;

const CarouselItemContent = styled.div`
  flex: 1;

  @media (min-width: 852px) {
  }

  @media (min-width: 1110px) {
    padding-right: 148px;
  }
`;

const Headline = styled.div`
  color: #1346c7;
  font-size: 28px;
  letter-spacing: 1.12px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 12px;
`;

const Description = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 18px;
  line-height: 36px;
  letter-spacing: 0.36px;
`;

const CtaLabel = styled.div`
  padding-top: 16px;
  a {
    color: #1346c7;
    font-weight: 600;
    font-size: 18px;
    line-height: 38px;
    letter-spacing: 0.36px;
    text-decoration: none;

    &:hover {
      color: #3a6dec;
    }

    &:active {
      color: #0c2d81;
    }
  }
`;

function PartnerCarousel({ input }) {
  const settings = {
    className: 'partner-carousel',
    arrows: false,
    centerMode: true,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 1,
    speed: 600,
    dots: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
    pauseOnFocus: true,
  };

  const initialSlide = Math.floor(Math.random() * input.items.length);
  settings.initialSlide = initialSlide;

  let carouselWidth = 990;

  if (typeof window !== 'undefined') {

    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, []);

    if (windowWidth < 450) {
      carouselWidth = 320;
    } else if (windowWidth < 852) {
      carouselWidth = 444;
    } else if (windowWidth < 1110) {
      carouselWidth = 732;
    }
  }

  return (
    <PartnerCarouselContainer>
      <Slider {...settings}>
        {input.items.map((item, i) => {
          return (
            <CarouselItem key={i} style={{width: carouselWidth}}>
              <CarouselItemInner className="partner-carousel-inner">
                <ImgContainer>
                  <img src={item.image.url} />
                </ImgContainer>
                <CarouselItemContent>
                  <Headline>{item.headline.text}</Headline>
                  <Description>{item.description.text}</Description>
                  <CtaLabel>
                    <a href={item.cta_link.url} target="_blank" rel="noopener noreferrer">
                      {item.cta_label.text}
                    </a>
                  </CtaLabel>
                </CarouselItemContent>
              </CarouselItemInner>
            </CarouselItem>
          );
        })}
      </Slider>
    </PartnerCarouselContainer>
  );
}

export { PartnerCarousel };
